/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_LeadInputs */

const en_mk_sol_ukm_lead = /** @type {(inputs: Mk_Sol_Ukm_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five branches, a back office of four. The work repeats daily — sales recaps, promo scheduling, answering complaints — and that is exactly what drains people.`)
};

const id_mk_sol_ukm_lead = /** @type {(inputs: Mk_Sol_Ukm_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lima cabang, satu tim kantor berisi empat orang. Pekerjaannya berulang tiap hari — rekap penjualan, jadwal promo, balas komplain — dan justru itu yang paling memakan tenaga.`)
};

/**
* | output |
* | --- |
* | "Five branches, a back office of four. The work repeats daily — sales recaps, promo scheduling, answering complaints — and that is exactly what drains people." |
*
* @param {Mk_Sol_Ukm_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_lead = /** @type {((inputs?: Mk_Sol_Ukm_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_lead(inputs)
	return en_mk_sol_ukm_lead(inputs)
});